// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

function RDTableBodyCell({ noBorder, align, style, children }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={3}
      style={style}
      // sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
      //   fontSize: size.sm,
      //   borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
      // })}
    >
      <MDBox
        display="inline-block"
        // width="max-content"
        color={style ? style.color : 'text'}
        // color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of RDTableBodyCell
RDTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

// Typechecking props for the RDTableBodyCell
RDTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  style: PropTypes.object
};

export default RDTableBodyCell;
